import { withInstall } from '@visual-design/utils'
import Card from './src/card.vue'
import GradientCard from './src/gradient-card.vue'

export const VCard = withInstall(Card)
export const VGradientCard = withInstall(GradientCard)

export default VCard
